/* global fitData */

(function () {
  'use strict';

  function reverse(arr) {
    var copy = Array.prototype.slice.call(arr);
    copy.reverse();
    return copy;
  }
  var id = 'accenture';
  var freshnessFields = [{
    name: "Freshness Score",
    field: "freshnessScore"
  }, {
    name: "Board Updates",
    field: "updates"
  }];
  var popularityFields = [{
    name: "Popularity Score",
    field: "popularityScore"
  }, {
    name: "Board Likes",
    field: "netLikes"
  }, {
    name: "Board Completions",
    field: "completions"
  }, {
    name: "Board Endorsements",
    field: "endorsements"
  }, {
    name: "Board Views",
    field: "views"
  }, {
    name: "Board Shares",
    field: "shares"
  }, {
    name: "Board Followers",
    field: "followers"
  }];

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').
  // All injectable services need to be named with a prefix (id) to "namespace" them since we are operating
  // within one global wsLrs module that's shared by all CardTemplates.
  factory(id + ".Utils", ['Api', 'CardQueryResource', function (Api, CardQueryResource) {
    /*jshint camelcase: false */
    return {
      fetchData: function fetchData() {
        var self = this;
        return CardQueryResource.getWithProgress({
          path: '/accenture/data',
          progressChannel: 'accenture'
        }).then(function (data) {
          return self.processData(data.results[0].result.learningBoards);
        });
      },
      processData: function processData(learningBoardData) {
        function getDelta(data) {
          if (data.length > 1) {
            return data[data.length - 1] - data[data.length - 2];
          } else {
            return null;
          }
        }
        function getChartData(aggregations, fieldName) {
          var chartData = {
            value: 0,
            change: 0,
            sparkline: _.map(aggregations, function (x) {
              return x[fieldName];
            })
          };
          var historicalData = chartData.sparkline;
          if (historicalData.length > 0) {
            chartData.value = historicalData[historicalData.length - 1];
          }
          chartData.change = getDelta(historicalData);
          return chartData;
        }

        // Now get the data ready for UI use
        _.each(learningBoardData, function (data) {
          // First thing, remove the current week's data because it's an incomplete set of data
          data.aggregations.pop();
          _.each(popularityFields, function (f) {
            data[f.field] = getChartData(data.aggregations, f.field);
            data[f.field + "Rank"] = getChartData(data.aggregations, f.field + "Rank");
          });
          _.each(freshnessFields, function (f) {
            data[f.field] = getChartData(data.aggregations, f.field);
            data[f.field + "Rank"] = getChartData(data.aggregations, f.field + "Rank");
          });

          // This metrics array is simply to facilitate table rendering with ng-repeat
          data.metrics = [data.netLikes, data.completions, data.endorsements, data.views, data.shares, data.followers];
          data.ranks = [data.netLikesRank, data.completionsRank, data.endorsementsRank, data.viewsRank, data.sharesRank, data.followersRank];
        });
        return learningBoardData;
      },
      searchAndSort: function searchAndSort(learningBoardData, params) {
        /*jshint camelcase: false */
        // Filter if we have a name search
        if (params.in_name) {
          learningBoardData = _.filter(learningBoardData, function (x) {
            var name = x.name.toLowerCase();
            var searchString = params.in_name.toLowerCase();
            return name.indexOf(searchString) > -1;
          });
        }
        var limit = params._limit || params.limit || 10,
          offset = params._offset || 0;
        if (params.order_by) {
          var reverse = false;
          var orderBy = params.order_by;
          if (orderBy.lastIndexOf("-", 0) === 0) {
            orderBy = orderBy.substring(1, orderBy.length);
            reverse = true;
          }
          var orderingMethod = null;
          if (orderBy === "name") {
            orderingMethod = function orderingMethod(board) {
              return board.name.toLowerCase();
            };
          } else if (orderBy === "lastUpdated") {
            orderingMethod = function orderingMethod(board) {
              return board.lastUpdated;
            };
          } else {
            orderingMethod = function orderingMethod(board) {
              return board[orderBy].value;
            };
          }
          learningBoardData = _.sortBy(learningBoardData, orderingMethod);
          if (reverse) {
            learningBoardData.reverse();
          }
          var numResults = _.size(learningBoardData);
          learningBoardData = learningBoardData.slice(offset, limit + offset);
          return {
            "results": learningBoardData,
            "count": numResults
          };
        }
      }
    };
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/' + id + '/learningboard-popularity/:cardId', {
      templateUrl: 'modules/app/accenture/popularityDetail.html',
      controller: id + ".popularity.Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/' + id + '/learningboard-freshness/:cardId', {
      templateUrl: 'modules/app/accenture/freshnessDetail.html',
      controller: id + ".freshness.Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/' + id + '/learningboard-correlation/:cardId', {
      templateUrl: 'modules/app/accenture/correlationDetail.html',
      controller: id + ".correlation.Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    //Register card icon preferences
    CardIconMap.register({
      "accenture#learningboard-popularity": "toolbox",
      "accenture#learningboard-freshness": "toolbox",
      "accenture#learningboard-correlation": "toolbox"
    });
  }]).controller(id + ".popularity.Card", ["$scope", "CardRegistry", id + ".Utils", function ($scope, CardRegistry, Utils) {
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    Utils.fetchData().then(function (learningBoardData) {
      $scope.learningBoardData = _.sortBy(learningBoardData, function (val) {
        return val.popularityScore.value;
      });
      $scope.learningBoardData = reverse($scope.learningBoardData);
      $scope.hasData = true;
    });
  }]).controller(id + ".popularity.Detail", ["$scope", "$routeParams", "CardRegistry", "CardUtils", id + ".Utils", "$controller", "$q", 'wsColors', function ($scope, $routeParams, CardRegistry, CardUtils, Utils, $controller, $q, wsColors) {
    $scope.cardId = $routeParams.cardId;
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    CardUtils.setNavElements($scope, $routeParams.cardId);
    $scope.sparklineOptions = {
      type: 'line',
      spotRadius: 0,
      fillColor: false,
      lineColor: wsColors.wsBlue
    };
    $scope.getColor = function getColor(val) {
      if (val > 0) {
        return "green";
      }
    };
    $scope.searchPlaceholder = "Search by Board Name";
    $scope.defaultSortBy = "-netLikes";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });

    /*jshint camelcase: false */
    $scope.fetchData = function fetchData(params) {
      if ($scope.fetchInProgress) {
        return $scope.dataFetched;
      } else if ($scope.learningBoardData) {
        var sortedList = Utils.searchAndSort($scope.learningBoardData, params);
        var deferred = $q.defer();
        deferred.resolve(sortedList);
        $scope.hasData = $scope.learningBoardData.length > 0;
        return deferred.promise;
      } else {
        $scope.fetchInProgress = true;
        return Utils.fetchData().then(function (learningBoardData) {
          // Default Sort
          $scope.learningBoardData = _.sortBy(learningBoardData, function (val) {
            return val[$scope.defaultSortBy.replace("-", "")].value;
          });
          $scope.learningBoardData = reverse($scope.learningBoardData);
          var limit = params._limit || params.limit || 10,
            offset = params._offset || 0,
            vals = $scope.learningBoardData;
          var numResults = _.size(vals);
          vals = vals.slice(offset, limit + offset);
          $scope.fetchInProgress = false;
          $scope.hasData = $scope.learningBoardData.length > 0;
          return {
            "results": vals,
            "count": numResults
          };
        });
      }
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      var deferred = $q.defer();
      var matches = _.filter($scope.learningBoardData, function (x) {
        var name = x.name.toLowerCase();
        var searchString = params.in_name.toLowerCase();
        return name.indexOf(searchString) > -1;
      });
      deferred.resolve({
        "results": matches
      });
      return deferred.promise;
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + ".popularity.CountLister", ["$scope", function ($scope) {
    $scope.sortControls = [{
      "title": "Board Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Likes",
      "options": {
        "Ascending": "netLikes",
        "Descending": "-netLikes"
      }
    }, {
      "title": "Completions",
      "options": {
        "Ascending": "completions",
        "Descending": "-completions"
      }
    }, {
      "title": "Endorsements",
      "options": {
        "Ascending": "endorsements",
        "Descending": "-endorsements"
      }
    }, {
      "title": "Views",
      "options": {
        "Ascending": "views",
        "Descending": "-views"
      }
    }, {
      "title": "Shares",
      "options": {
        "Ascending": "shares",
        "Descending": "-shares"
      }
    }, {
      "title": "Followers",
      "options": {
        "Ascending": "followers",
        "Descending": "-followers"
      }
    }];
  }]).controller(id + ".popularity.PopularityLister", ["$scope", function ($scope) {
    $scope.sortControls = [{
      "title": "Popularity<br/>Rank",
      "options": {
        "Ascending": "popularityScoreRank",
        "Descending": "-popularityScoreRank"
      }
    }, {
      "title": "Board Name<br/>Rank",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Likes<br/>Rank",
      "options": {
        "Ascending": "netLikesRank",
        "Descending": "-netLikesRank"
      }
    }, {
      "title": "Completions<br/>Rank",
      "options": {
        "Ascending": "completionsRank",
        "Descending": "-completionsRank"
      }
    }, {
      "title": "Endorsements<br/>Rank",
      "options": {
        "Ascending": "endorsementsRank",
        "Descending": "-endorsementsRank"
      }
    }, {
      "title": "Views<br/>Rank",
      "options": {
        "Ascending": "viewsRank",
        "Descending": "-viewsRank"
      }
    }, {
      "title": "Shares<br/>Rank",
      "options": {
        "Ascending": "sharesRank",
        "Descending": "-sharesRank"
      }
    }, {
      "title": "Followers<br/>Rank",
      "options": {
        "Ascending": "followersRank",
        "Descending": "-followersRank"
      }
    }, {
      "title": "Score<br/><Rank></Rank>",
      "options": {
        "Ascending": "popularityScore",
        "Descending": "-popularityScore"
      }
    }];
    $scope.renderHiddenSparklines = function () {
      setTimeout(function () {
        /*jshint camelcase: false */
        $.sparkline_display_visible();
      });
    };
  }]).controller(id + ".freshness.Card", ["$scope", "CardRegistry", id + ".Utils", function ($scope, CardRegistry, Utils) {
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    Utils.fetchData().then(function (learningBoardData) {
      $scope.learningBoardData = _.sortBy(learningBoardData, function (val) {
        return val.freshnessScore.value;
      });
      $scope.learningBoardData = reverse($scope.learningBoardData);
      $scope.hasData = true;
    });
  }]).controller(id + ".freshness.Detail", ["$scope", "$routeParams", "CardRegistry", "CardUtils", id + ".Utils", "$controller", "$q", 'wsColors', function ($scope, $routeParams, CardRegistry, CardUtils, Utils, $controller, $q, wsColors) {
    $scope.cardId = $routeParams.cardId;
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    CardUtils.setNavElements($scope, $routeParams.cardId);
    $scope.sparklineOptions = {
      type: 'line',
      spotRadius: 0,
      fillColor: false,
      lineColor: wsColors.wsBlue
    };
    $scope.getColor = function getColor(val) {
      if (val > 0) {
        return "green";
      }
    };
    $scope.searchPlaceholder = "Search by Board Name";
    $scope.defaultSortBy = "-updates";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });

    /*jshint camelcase: false */
    $scope.fetchData = function fetchData(params) {
      if ($scope.fetchInProgress) {
        return $scope.dataFetched;
      } else if ($scope.learningBoardData) {
        var sortedList = Utils.searchAndSort($scope.learningBoardData, params);
        var deferred = $q.defer();
        deferred.resolve(sortedList);
        $scope.hasData = $scope.learningBoardData.length > 0;
        return deferred.promise;
      } else {
        $scope.fetchInProgress = true;
        return Utils.fetchData().then(function (learningBoardData) {
          function createAgingChart($scope) {
            // 30 days ago
            var now = new Date();
            var thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(now.getDate() - 28);
            var sixtyDaysAgo = new Date();
            sixtyDaysAgo.setDate(now.getDate() - 56);
            var ninetyDaysAgo = new Date();
            ninetyDaysAgo.setDate(now.getDate() - 84);
            var updates4 = 0;
            var updates8 = 0;
            var updates12 = 0;
            var updatesOlder = 0;
            _.each($scope.learningBoardData, function (board) {
              _.each(board.aggregations, function (agg) {
                var aggDate = new Date(agg.date);
                if (aggDate > thirtyDaysAgo) {
                  updates4 += agg.updates;
                } else if (aggDate > sixtyDaysAgo) {
                  updates8 += agg.updates;
                } else if (aggDate > ninetyDaysAgo) {
                  updates12 += agg.updates;
                } else {
                  updatesOlder += agg.updates;
                }
              });
            });
            $scope.agingChart = {
              chart: {
                type: 'column'
              },
              tooltip: {
                pointFormat: "<span style=\"color:{point.color}\">\u2022</span> {series.name}: <b>{point.y}</b><br/>"
              },
              title: {
                text: null
              },
              xAxis: {
                categories: ['Updated in last 4 weeks', 'Updated 4-8 weeks ago', 'Updated 8-12 weeks ago', 'Updated over 12 weeks ago']
              },
              yAxis: {
                min: 0,
                title: {
                  text: 'Learning Board Updates'
                }
              },
              series: [{
                name: 'All Learning Boards',
                data: [updates4, updates8, updates12, updatesOlder]
              }]
            };
          }

          // Default Sort
          $scope.learningBoardData = _.sortBy(learningBoardData, function (val) {
            return val[$scope.defaultSortBy.replace("-", "")].value;
          });
          $scope.learningBoardData = reverse($scope.learningBoardData);
          var limit = params._limit || params.limit || 10,
            offset = params._offset || 0,
            vals = $scope.learningBoardData;
          var numResults = _.size(vals);
          vals = vals.slice(offset, limit + offset);
          $scope.fetchInProgress = false;
          createAgingChart($scope);
          $scope.hasData = $scope.learningBoardData.length > 0;
          return {
            "results": vals,
            "count": numResults
          };
        });
      }
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      var deferred = $q.defer();
      var matches = _.filter($scope.learningBoardData, function (x) {
        var name = x.name.toLowerCase();
        var searchString = params.in_name.toLowerCase();
        return name.indexOf(searchString) > -1;
      });
      deferred.resolve({
        "results": matches
      });
      return deferred.promise;
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + ".freshness.CountLister", ["$scope", function ($scope) {
    $scope.sortControls = [{
      "title": "Board Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Updates",
      "options": {
        "Ascending": "updates",
        "Descending": "-updates"
      }
    }, {
      "title": "Last Updated",
      "options": {
        "Ascending": "lastUpdated",
        "Descending": "-lastUpdated"
      }
    }];
  }]).controller(id + ".freshness.RankLister", ["$scope", function ($scope) {
    $scope.renderHiddenSparklines = function () {
      setTimeout(function () {
        /*jshint camelcase: false */
        $.sparkline_display_visible();
        $scope.setSort("popularity-rank");
      });
    };
    $scope.sortControls = [{
      "title": "Freshness Rank",
      "options": {
        "Ascending": "freshnessScoreRank",
        "Descending": "-freshnessScoreRank"
      }
    }, {
      "title": "Board Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Updates Rank",
      "options": {
        "Ascending": "updatesRank",
        "Descending": "-updatesRank"
      }
    }, {
      "title": "Freshness Score",
      "options": {
        "Ascending": "freshnessScore",
        "Descending": "-freshnessScore"
      }
    }];
  }]).controller(id + ".correlation.Card", ["$scope", "CardRegistry", id + ".Utils", 'wsColors', function ($scope, CardRegistry, Utils, wsColors) {
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    Utils.fetchData().then(function (learningBoardData) {
      $scope.chartConfig = {
        chart: {
          type: 'scatter',
          zoomType: 'xy'
        },
        title: {
          text: null
        },
        tooltip: {
          formatter: function formatter() {
            var tooltip = "<strong>" + this.point.name + "</strong> ";
            tooltip += "<br/>Popularity Score: " + Math.round(this.point.y * 10) / 10 + "<br/>Freshness Score: " + Math.round(this.point.x * 10) / 10;
            return tooltip;
          }
        },
        xAxis: {
          title: {
            enabled: true,
            text: 'Freshness Score'
          },
          startOnTick: true,
          endOnTick: true,
          showLastLabel: true,
          min: 0
        },
        yAxis: {
          title: {
            text: 'Popularity Score'
          },
          min: 0
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          scatter: {
            marker: {
              radius: 5,
              states: {
                hover: {
                  enabled: true,
                  lineColor: wsColors.wsGray
                }
              }
            },
            states: {
              hover: {
                marker: {
                  enabled: false
                }
              }
            }
          }
        },
        series: [{
          color: wsColors.getRGBA(wsColors.wsBlue, 0.5),
          data: _.map(learningBoardData, function (board) {
            return {
              x: board.freshnessScore.value,
              y: board.popularityScore.value,
              name: board.name
            };
          })
        }, {
          type: 'line',
          enableMouseTracking: false,
          marker: {
            enabled: false
          },
          data: function () {
            return fitData(_.map(learningBoardData, function (board) {
              return [board.freshnessScore.value, board.popularityScore.value];
            })).data;
          }()
        }]
      };
      $scope.hasData = true;
    });
  }]).controller(id + ".correlation.Detail", ["$scope", "CardRegistry", id + ".Utils", "$routeParams", "CardUtils", 'wsColors', function ($scope, CardRegistry, Utils, $routeParams, CardUtils, wsColors) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    CardUtils.setNavElements($scope, $routeParams.cardId);
    Utils.fetchData().then(function (learningBoardData) {
      $scope.learningBoardData = learningBoardData;
      $scope.hasData = $scope.learningBoardData.length > 0;
      $scope.scopeOptions = ["All Learning Boards", "Top 10 Learning Boards"];
      $scope.selectedScope = $scope.scopeOptions[1];
      $scope.freshnessFields = freshnessFields;
      $scope.popularityFields = popularityFields;
      $scope.updateScope = function updateScope(scope) {
        $scope.selectedScope = scope;
        $scope.createVsChartConfig($scope);
      };
      $scope.vsXField = $scope.freshnessFields[0];
      $scope.vsYField = $scope.popularityFields[0];
      $scope.createVsChartConfig = function createVsChartConfig($scope) {
        $scope.popularityVsFreshnessChart = {
          chart: {
            type: 'scatter',
            zoomType: 'xy'
          },
          title: {
            text: null
          },
          tooltip: {
            formatter: function formatter() {
              var tooltip = "<strong>" + this.point.name + "</strong> ";
              tooltip += "<br/>" + $scope.vsYField.name + ": " + Math.round(this.point.y * 10) / 10 + "<br/>" + $scope.vsXField.name + ": " + Math.round(this.point.x * 10) / 10;
              return tooltip;
            }
          },
          xAxis: {
            title: {
              enabled: true,
              text: $scope.vsXField.name
            },
            min: 0
          },
          yAxis: {
            title: {
              text: $scope.vsYField.name
            },
            min: 0
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            scatter: {
              marker: {
                radius: 5,
                states: {
                  hover: {
                    enabled: true,
                    lineColor: wsColors.wsGray
                  }
                }
              },
              states: {
                hover: {
                  marker: {
                    enabled: false
                  }
                }
              }
            }
          },
          series: [{
            color: wsColors.getRGBA(wsColors.wsBlue, 0.5),
            name: $scope.vsXField.name + " vs. " + $scope.vsYField.name
          }, {
            type: 'line',
            enableMouseTracking: false,
            marker: {
              enabled: false
            }
          }]
        };

        // Now add the chart series data
        if ($scope.selectedScope === "All Learning Boards") {
          $scope.popularityVsFreshnessChart.series[0].data = _.map($scope.learningBoardData, function (board) {
            return {
              x: board[$scope.vsXField.field].value,
              y: board[$scope.vsYField.field].value,
              name: board.name
            };
          });
        } else if ($scope.selectedScope === "Top 10 Learning Boards") {
          // Sort by popularity first
          $scope.learningBoardData = _.sortBy(learningBoardData, function (val) {
            return val.popularityScoreRank.value;
          });
          var data = _.map($scope.learningBoardData, function (board) {
            return {
              x: board[$scope.vsXField.field].value,
              y: board[$scope.vsYField.field].value,
              name: board.name
            };
          });
          $scope.popularityVsFreshnessChart.series[0].data = _.first(data, 10);
        }

        // Update fit line
        $scope.popularityVsFreshnessChart.series[1].data = function () {
          return fitData($scope.popularityVsFreshnessChart.series[0].data).data;
        }();
      };

      // Initial rendering
      $scope.createVsChartConfig($scope);
      $scope.$watch('vsXField', function (oldVal, newVal) {
        if (oldVal !== newVal) {
          $scope.createVsChartConfig($scope);
        }
      });
      $scope.$watch('vsYField', function (oldVal, newVal) {
        if (oldVal !== newVal) {
          $scope.createVsChartConfig($scope);
        }
      });
      $scope.timespanOptions = ["past 4 weeks", "past 8 weeks", "past 12 weeks"];
      $scope.selectedTimespan = $scope.timespanOptions[2];
      $scope.updateTimespan = function updateTimespan(timespan) {
        $scope.selectedTimespan = timespan;
        $scope.createChangesChartConfig($scope);
      };
      $scope.changesXField = $scope.freshnessFields[0];
      $scope.changesYField = $scope.popularityFields[0];
      $scope.createChangesChartConfig = function createChangesChartConfig($scope) {
        $scope.changesChart = {
          chart: {
            type: 'scatter',
            zoomType: 'xy'
          },
          title: {
            text: null
          },
          tooltip: {
            formatter: function formatter() {
              var tooltip = "<strong>" + this.point.name + "</strong> ";
              tooltip += "<br/>" + $scope.changesYField.name + ": " + Math.round(this.point.y * 10) / 10 + "<br/>" + $scope.changesXField.name + ": " + Math.round(this.point.x * 10) / 10;
              return tooltip;
            }
          },
          xAxis: {
            title: {
              enabled: true,
              text: $scope.changesXField.name
            },
            min: 0
          },
          yAxis: {
            title: {
              text: $scope.changesYField.name
            },
            min: 0
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            scatter: {
              marker: {
                radius: 5,
                states: {
                  hover: {
                    enabled: true,
                    lineColor: wsColors.wsGray
                  }
                }
              },
              states: {
                hover: {
                  marker: {
                    enabled: false
                  }
                }
              }
            }
          },
          series: [{
            color: wsColors.getRGBA(wsColors.wsBlue, 0.5),
            name: $scope.changesXField.name + " vs. " + $scope.changesYField.name
          }, {
            type: 'line',
            enableMouseTracking: false,
            marker: {
              enabled: false
            }
          }]
        };
        var weeksBack = 0;
        if ($scope.selectedTimespan === "past 4 weeks") {
          weeksBack = 4;
        } else if ($scope.selectedTimespan === "past 8 weeks") {
          weeksBack = 8;
        } else {
          weeksBack = 12;
        }

        // Now add athe chart series data
        $scope.changesChart.series[0].data = _.map($scope.learningBoardData, function (board) {
          return {
            x: _.reduce(_.last(board[$scope.changesXField.field].sparkline, weeksBack), function (total, val) {
              return total + val;
            }),
            y: _.reduce(_.last(board[$scope.changesYField.field].sparkline, weeksBack), function (total, val) {
              return total + val;
            }),
            name: board.name
          };
        });

        // Update the fit line as well
        $scope.changesChart.series[1].data = function () {
          return fitData($scope.changesChart.series[0].data).data;
        }();
      };

      // Initial rendering
      $scope.createChangesChartConfig($scope);
      $scope.$watch('changesXField', function (oldVal, newVal) {
        if (oldVal !== newVal) {
          $scope.createChangesChartConfig($scope);
        }
      });
      $scope.$watch('changesYField', function (oldVal, newVal) {
        if (oldVal !== newVal) {
          $scope.createChangesChartConfig($scope);
        }
      });
    });
  }]);
})();
